import React, { useContext, useEffect } from 'react'

import { Errors, FieldNames, FormContext, Validation } from '@ecm/data/Form'
import { FormContextFull } from '@ecm/ui/element/input/Form'
import { BaseInput, InputProps } from '@ecm/ui/element/input/Input'

export type FormInputProps = InputProps & {
  validation: Validation | Validation[]
  inputToCompare?: string
}
export const FormInput = ({
  focus,
  id,
  initialValue,
  label,
  margin,
  name,
  placeHolder,
  validation,
  width,
  type,
  inputToCompare,
  errorAutoHeight,
}: FormInputProps) => {
  const formContext: FormContext = useContext(FormContextFull)

  useEffect(() => {
    if (validation) {
      if (Array.isArray(validation)) {
        validation.forEach(v => {
          formContext.addValidator({ [name]: v.rule })
        })
      } else {
        formContext.addValidator({ [name]: validation.rule })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setValue(name, initialValue || '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue, name])

  const setValue = (name: FieldNames, value: string): void => {
    if (getError(formContext.errors, name)) {
      const error = Array.isArray(validation) ? validation[0].rule(value) : validation.rule(value)
      formContext.setErrors({ [id]: error })
    }
    formContext.setValues({ [name]: value })
  }

  return (
    <BaseInput
      error={getError(formContext.errors, name)}
      focus={focus}
      id={id}
      initialValue={initialValue}
      label={label}
      margin={margin}
      name={name}
      placeHolder={placeHolder}
      errorAutoHeight={errorAutoHeight}
      onBlur={(ev: React.SyntheticEvent<HTMLInputElement>): void => {
        formContext.setErrors({ [id]: validate(ev, validation, inputToCompare) })
      }}
      onChange={(ev: React.SyntheticEvent<HTMLInputElement>): void => {
        setValue(name, ev.currentTarget.value)
      }}
      width={width}
      type={type}
    />
  )
}

const validate = (
  event: React.SyntheticEvent<HTMLInputElement>,
  validation: Validation | Validation[],
  inputToCompare?: string
): string => {
  const value = event.currentTarget.value
  const secondValue = inputToCompare
    ? (document.getElementById(inputToCompare) as HTMLInputElement)?.value
    : undefined
  if (Array.isArray(validation)) {
    const validationWithError = validation.find(v => {
      return v.rule(value, secondValue)
    })
    if (validationWithError) {
      return validationWithError.rule(value, secondValue)
    }
    return ''
  } else {
    return validation.rule(value, secondValue)
  }
}
const getError = (errors: Errors, name: FieldNames): string => {
  if (errors) {
    return errors[name] || ''
  }
  return ''
}

export default FormInput
